import splunkSpl from "refractor/splunk-spl";
export default splunkSpl;